package app.bloomey.web.components.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.MutableState
import androidx.compose.runtime.mutableStateOf
import app.bloomey.web.components.widgets.SiteTextInput
import app.bloomey.web.components.widgets.SiteTextInputSearchVariant
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.core.rememberPageContext
import org.jetbrains.compose.web.css.px

@Composable
fun PageActionsBar(
    modifier: Modifier = Modifier,
    searchValue: MutableState<String> = mutableStateOf(""),
    onSearch: (() -> Unit)? = null,
) {
    val router = rememberPageContext().router
    Row(
        modifier = modifier.fillMaxWidth()
            .height(100.px)
            .padding(topBottom = 20.px)
    ) {
        SiteTextInput(
            text = searchValue.value, label = "Search",
            variant = SiteTextInputSearchVariant,
            onCommit = {
                onSearch?.invoke()
                router.navigateTo("?q=${searchValue.value}")
            }
        ) {
            searchValue.value = it
        }
    }
}